import { Type } from "class-transformer";
import { ProxyConnectionParams } from "./ProxyConnectionParams";

export class FtpConnectionParams {
    port = 0;
    sftp = false;
    @Type(() => ProxyConnectionParams)
    proxy: ProxyConnectionParams;
}
